module.exports = __webpack_public_path__ + "static/media/IMG_0538.30bba13e.JPG";